export const ENTRA_START_PATH = '/api/auth/entra/start';

export type MicrosoftLoginHash = { kind: 'ticket'; ticket: string } | { kind: 'denied'; email: string } | { kind: 'failed' } | { kind: 'empty' };

export function parseMicrosoftLoginHash(hash: string): MicrosoftLoginHash {
    const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
    const ticket = params.get('ticket');
    if (ticket) {
        return { kind: 'ticket', ticket };
    }
    const erro = params.get('erro');
    if (erro === 'sem-acesso') {
        const email = params.get('email');
        if (email) {
            return { kind: 'denied', email };
        }
    }
    if (erro) {
        return { kind: 'failed' };
    }
    return { kind: 'empty' };
}

export function shouldAutoStartMicrosoftLogin(input: { userAgent: string; hasSession: boolean; enabled: boolean; hash: MicrosoftLoginHash }): boolean {
    return input.enabled && !input.hasSession && input.userAgent.includes('Orbit/') && input.hash.kind === 'empty';
}

export function startMicrosoftLogin(): void {
    window.location.assign(ENTRA_START_PATH);
}
